import React, { Component,useState } from "react";
import { withRouter } from 'react-router-dom';
import MuiSwitch from "@mui/material/Switch";

import {
    Alert,
    Box,
    Button,
    FormHelperText,
    Link,
    Stack,
    Tab,
    Tabs,
    TextField ,
    Typography
} from '@mui/material';


import AlertTitle from '@mui/material/AlertTitle';
import { connect } from "react-redux";
import { Layout } from "../../layouts/auth/layout";
import { login, me, setServerType } from "../../store/actions/auth";
import { useDispatch,useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
 const Login = (...props) => {
 const [loading, setLoading] = useState(false);
 const [form, setForm] = useState({  username: '' , password: '' });
 const [errors, setErrors] = useState({});
 const [error, setError] = useState("");
 const dispatch = useDispatch();
 const history = useHistory();
 const session = useSelector(state => state.session.session);
 const server  = useSelector(state => state.server.serverType);
   const submit= async () =>{
        setLoading(true);
        setError("");
        try {
            const response = await  dispatch(login(form.username, form.password));
            // window.location.href = '/home';
            history.push('/home'); 
        } catch(err) {
            console.log('ist eroro a 2222');
            setError("Email ou mot de passe incorrect");
        } finally {
            setLoading(false);
        }
    }

    const changeFormAttribute = (name, value) =>{
            setForm( {
                ...form,
                [name]: value
            })
    }


    return (
            <>
                <>
                    <Layout>
                        <Box
                            sx={{
                                flex: '1 1 auto',
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <Box
                                sx={{
                                    backgroundColor: "white",
                                    zIndex: 1,
                                    borderRadius: 1,
                                    maxWidth: 550,
                                    px: 3,
                                    width: '100%',
                                    padding: '24px 24px',
                                    boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                                }}
                            >
                                <div>



                                    <Stack
                                        spacing={1}
                                        sx={{ mb: 3 }}
                                    >
                                        <Typography variant="h4">
                                            Authentification
                                        </Typography>

                                    </Stack>

                                    {
                                        error &&
                                        <Alert severity="error" variant="filled" sx={{ mb: 2 }}>
                                            <AlertTitle>Erreur</AlertTitle>
                                            {error}
                                        </Alert>
                                    }

                                    <form
                                        noValidate
                                        onSubmit={() => {
                                        }}
                                    >
                                        <Stack spacing={3}>
                                               <TextField
                                                error={false}
                                                fullWidth
                                                helperText={""}
                                                label="Email Address"
                                                name="email"
                                                onBlur={() => { }}
                                                onChange={(e) => changeFormAttribute("username", e.target.value)}
                                                type="email"
                                                value={form.username}
                                               />
                                               <TextField
                                                error={false}
                                                fullWidth
                                                helperText={() => {
                                                }}
                                                label="Password"
                                                name="password"
                                                onBlur={() => { }}
                                                onChange={(e) => changeFormAttribute("password", e.target.value)}
                                                type="password"
                                                value={form.password}
                                                />
                                         </Stack>
                                         {/* <p style={{marginTop:8,marginBottom:8,fontFamily:"Plus Jakarta Sans,sans-serif"}} >
                                            Serveur selectionné : {server??"<< dz >>"} 
                                         </p> */}
                                         <div style={{display:'flex',flexDirection:'row',columnGap:8,marginTop:8}} >
                                            <div onClick={()=>dispatch(setServerType('eu'))} style={{width:"50%",padding:16,backgroundColor:"rgb(27, 79, 77)",borderRadius:8,color:'white',opacity:server=="dz"?0.5:1}} >
                                            <Typography variant="h6">
                                            EUROPE
                                            </Typography>
                                                
                                            </div>
                                            <div onClick={()=>dispatch(setServerType('dz'))} style={{width:"50%",padding:16,backgroundColor:"rgb(27, 79, 77)",borderRadius:8,color:"white",opacity:server!="dz"?0.5:1}} >
                                            <Typography variant="h6">
                                            DZ
                                            </Typography>
                                            </div>
                                         </div>
                                        <Button
                                            fullWidth
                                            size="large"
                                            sx={{ mt: 3 }}
                                            type="submit"
                                            variant="contained"
                                            disabled={loading}

                                            onClick={(e) => {
                                                e.preventDefault()
                                                submit()
                                            }}
                                        >
                                            Se connecter
                                        </Button>

                                    </form>


                                </div>
                            </Box>
                        </Box>
                    </Layout>
                </>
            </>

    )
}

export default Login ;

// export default connect(mapStateToProps, {
//     login
// })(Login);
